import React, { useState, useEffect, useCallback } from 'react';
import styles from './index.module.sass';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';
import Alert from '../../Alert';
import OrderCard from '../../OrderCard';
import SectionTitle from '../../SectionTitle';
import uploadDocuments from '../../Queries/uploadDocuments';

const Documents = (props) => {
  const { device, getCookie } = props;
  const { screenSize } = device;

  const [addFieldsIFE, setAddFieldsIFE] = useState({
    imageIFE: '',
    typeDocIFE: '',
  });
  const [addFieldsContract, setAddFieldsContract] = useState({
    imageContract: '',
    typeDocContract: '',
  });
  const [addFieldsAdress, setAddFieldsAdress] = useState({
    imageAddress: '',
    typeDocAddress: '',
  });
  const [addFieldsCURP, setAddFieldsCURP] = useState({
    imageCURP: '',
    typeDocCURP: '',
  });
  const [addFieldsSAT, setAddFieldsSAT] = useState({
    imageSAT: '',
    typeDocSAT: '',
  });

  const [documents, setDocuments] = useState({
    IFE: '',
    Contract: '',
    Address: '',
    CURP: '',
    SAT: '',
  });
  const [existence, setExistence] = useState(false);
  const [existenceComplete, setexistenceComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('documents');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  async function submit() {
    setLoading(true);
    const kit = getCookie('usuarioOk');

    const jsonBody = {
      action: 'GENERAR',
      kit: kit,
      idFileName: addFieldsIFE.typeDocIFE,
      idBase64: addFieldsIFE.imageIFE,
      contractFileName: addFieldsContract.typeDocContract,
      contractBase64: addFieldsContract.imageContract,
      proofOfAddressFileName: addFieldsAdress.typeDocAddress,
      proofOfAddressBase64: addFieldsAdress.imageAddress,
      curpFileName: addFieldsCURP.typeDocCURP,
      curpBase64: addFieldsCURP.imageCURP,
      satFileName: addFieldsSAT.typeDocSAT,
      satBase64: addFieldsSAT.imageSAT,
    };

    const response = await uploadDocuments({ jsonBody });

    if (response.typeMessage === 'success') {
      setExistence(true);
      setAddFieldsIFE({
        imageIFE: '',
        typeDocIFE: '',
      });

      setAddFieldsContract({
        imageContract: '',
        typeDocContract: '',
      });

      setAddFieldsAdress({
        imageAddress: '',
        typeDocAddress: '',
      });

      setAddFieldsCURP({
        imageCURP: '',
        typeDocCURP: '',
      });

      setAddFieldsSAT({
        imageSAT: '',
        typeDocSAT: '',
      });
      showDocuments();
    } else {
      setAlertText(response.message);
      setOpen(true);
      return;
    }
    setLoading(false);
  }

  function uploadImage(typeDoc) {
    const file = document.querySelector('input[name=' + typeDoc + ']').files[0];

    const reader = new FileReader();

    let rawImg;
    reader.onloadend = () => {
      rawImg = reader.result;

      const imagenTmp = rawImg.split(',');
      if (imagenTmp.length >= 1) {
        const tipoDoc = file.type;
        const docTmp = tipoDoc.split('/');

        switch (typeDoc) {
          case 'IFE':
            setAddFieldsIFE({
              imageIFE: imagenTmp[1],
              typeDocIFE: 'IDENTIFICACION.' + docTmp[1],
            });
            break;

          case 'Contract':
            setAddFieldsContract({
              imageContract: imagenTmp[1],
              typeDocContract: 'CONTRATO.' + docTmp[1],
            });
            break;

          case 'Address':
            setAddFieldsAdress({
              imageAddress: imagenTmp[1],
              typeDocAddress: 'COMPROBANTE_DOMICILIO.' + docTmp[1],
            });
            break;

          case 'CURP':
            setAddFieldsCURP({
              imageCURP: imagenTmp[1],
              typeDocCURP: 'CURP.' + docTmp[1],
            });
            break;

          case 'SAT':
            setAddFieldsSAT({
              imageSAT: imagenTmp[1],
              typeDocSAT: 'SITUACION_FISCAL.' + docTmp[1],
            });
            break;

          default:
            break;
        }
      }
    };
    reader.readAsDataURL(file);
  }

  const showDocuments = useCallback(async () => {
    const kit = getCookie('usuarioOk');
    const jsonBody = {
      action: 'CONSULTAR',
      kit: kit,
      idFileName: '',
      idBase64: '',
      contractFileName: '',
      contractBase64: '',
      proofOfAddressFileName: '',
      proofOfAddressBase64: '',
      CURPFileName: '',
      CURPBase64: '',
      SATFileName: '',
      SATBase64: '',
    };

    const response = await uploadDocuments({ jsonBody });

    if (response.typeMessage === 'success') {
      setDocuments({
        IFE: response.pathToID,
        Contract: response.pathToContract,
        Address: response.pathToProofOfAddress,
        CURP: response.pathToCURP,
        SAT: response.pathToSAT,
      });
      setExistence(true);
      setExistence(true);
      if (
        response.pathToID !== '' &&
        response.pathToContract !== '' &&
        response.pathToProofOfAddress !== '' &&
        response.pathToCURP !== '' &&
        response.pathToSAT !== ''
      ) {
        setexistenceComplete(true);
      }
    }
  }, [getCookie]);

  useEffect(() => {
    showDocuments();
  }, [showDocuments]);

  function openPrivacy() {
    window.open('https://www.terramarbrands.com.mx/privacy');
  }

  return (
    <div className={`${styles[screenSize]} ${styles.documents}`}>
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <div className={screenSize !== 'phone' ? styles.container : styles.containerMobile}>
        <div className={screenSize !== 'phone' ? styles.formDocuments : styles.formDocumentsMobile}>
          <OrderCard>
            {!existenceComplete ? (
              <>
                {documents.IFE === '' && (
                  <>
                    <div className={styles.label}>
                      <label>{t('id')}</label>
                    </div>
                    <div className={styles.inputFile}>
                      <input
                        className={styles.fileInput}
                        type='file'
                        id='file'
                        name='IFE'
                        accept='image/*,application/pdf'
                        onChange={() => uploadImage('IFE')}
                      />
                    </div>
                  </>
                )}

                {documents.Contract === '' && (
                  <>
                    <div className={styles.label}>
                      <label>{t('contract')}</label>
                    </div>
                    <div className={styles.inputFile}>
                      <input
                        className={styles.fileInput}
                        type='file'
                        name='Contract'
                        accept='image/*,application/pdf'
                        onChange={() => uploadImage('Contract')}
                      />
                    </div>
                  </>
                )}

                {documents.Address === '' && (
                  <>
                    <div className={styles.label}>
                      <label>{t('address')}</label>
                    </div>
                    <div className={styles.inputFile}>
                      <input
                        className={styles.fileInput}
                        type='file'
                        name='Address'
                        accept='image/*,application/pdf'
                        onChange={() => uploadImage('Address')}
                      />
                    </div>
                  </>
                )}

                {documents.CURP === '' && (
                  <>
                    <div className={styles.label}>
                      <label>{t('CURP')}</label>
                    </div>
                    <div className={styles.inputFile}>
                      <input
                        className={styles.fileInput}
                        type='file'
                        name='CURP'
                        accept='image/*,application/pdf'
                        onChange={() => uploadImage('CURP')}
                      />
                    </div>
                  </>
                )}

                {documents.SAT === '' && (
                  <>
                    <div className={styles.label}>
                      <label>{t('SAT')}</label>
                    </div>
                    <div className={styles.inputFile}>
                      <input
                        className={styles.fileInput}
                        type='file'
                        name='SAT'
                        accept='image/*,application/pdf'
                        onChange={() => uploadImage('SAT')}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <div
                className={
                  screenSize !== 'phone' ? styles.formDocumentsNot : styles.formDocumentsNotMobile
                }>
                <div className={styles.title}>
                  <div>
                    <span className={`material-icons-outlined ${styles.tooltip}`}>info</span>
                  </div>
                  <div>Atención</div>
                </div>
                <div className={styles.titleNotFound}>{t('message')}</div>
              </div>
            )}

            {!loading ? (
              <div>
                {!existenceComplete && (
                  <div className={styles.button} onClick={() => submit()}>
                    <div>{t('save')}</div>
                  </div>
                )}

                <div className={styles.footerTitle}>
                  {t('footerTitle')}

                  <label className={styles.privacy} onClick={() => openPrivacy()}>
                    &nbsp;{t('privacy')}
                  </label>
                </div>
              </div>
            ) : (
              <CircularProgress className={styles.loading} />
            )}
          </OrderCard>
        </div>

        {existence ? (
          <div className={screenSize !== 'phone' ? styles.myDocuments : styles.myDocumentsMobile}>
            <OrderCard>
              <div className={styles.title}>
                <div>
                  <span className={`material-icons-outlined ${styles.tooltip}`}>feed</span>
                </div>
                <div>{t('title2')}</div>
              </div>
              {documents.IFE !== '' && (
                <li className={styles.listDoc}>
                  <a
                    className={styles.listDoc}
                    href={documents.IFE}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('id')}
                  </a>
                </li>
              )}

              {documents.Contract !== '' && (
                <li className={styles.listDoc}>
                  <a
                    className={styles.listDoc}
                    href={documents.Contract}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('contract')}
                  </a>
                </li>
              )}

              {documents.Address !== '' && (
                <li className={styles.listDoc}>
                  <a
                    className={styles.listDoc}
                    href={documents.Address}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('address')}
                  </a>
                </li>
              )}

              {documents.CURP !== '' && (
                <li className={styles.listDoc}>
                  <a
                    className={styles.listDoc}
                    href={documents.CURP}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('CURP')}
                  </a>
                </li>
              )}

              {documents.SAT !== '' && (
                <li className={styles.listDoc}>
                  <a href={documents.SAT} target='_blank' rel='noopener noreferrer'>
                    {t('SAT')}
                  </a>
                </li>
              )}
            </OrderCard>
          </div>
        ) : (
          <div className={screenSize !== 'phone' ? styles.myDocuments : styles.myDocumentsMobile}>
            <OrderCard>
              <div className={styles.title}>
                <div>
                  <span className={`material-icons-outlined ${styles.tooltip}`}>feed</span>
                </div>
                <div>{t('title2')}</div>
              </div>
              <div className={styles.titleNotFound}>{t('notFound')}</div>
            </OrderCard>
          </div>
        )}
      </div>
    </div>
  );
};

export default Documents;
